fragment ContactSearchResultByType on Contact {
    id
    name
    description
    initials
    htmlUrlPath
    avatarUrl
    accounts {
        primary {
            id
            name
        }
    }
    emailAddresses {
        primary {
            value {
                address
            }
        }
    }
    phones {
        primary {
            value {
                id
                numberFormatted
            }
        }
    }
}
